import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=ddac1dee&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddac1dee')) {
      api.createRecord('ddac1dee', component.options)
    } else {
      api.reload('ddac1dee', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=ddac1dee&", function () {
      api.rerender('ddac1dee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cAjWdx0io44T/JS/comp/openstreetmap.vue"
export default component.exports